import { usePasswordRecovery } from '../../contexts/PasswordRecoveryContext';
import { ResetPasswordStep } from '../ResetPasswordStep/ResetPasswordStep';
import { SendCodeStep } from '../SendCodeStep/SendCodeStep';
import { SuccessStep } from '../SuccessStep/SuccessStep';

export const PasswordRecoveryFlow = () => {
  const { state } = usePasswordRecovery();

  switch (true) {
    case state.step === 0:
      return <SendCodeStep />;
    case state.step === 1:
      return <ResetPasswordStep />;
    case state.step === 2:
      return <SuccessStep />;
    default:
      return null;
  }
};
